/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

